import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.jsx";

class FileUploadButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  handleChange(e) {
    e.preventDefault();
    this.props.onFileReceived({ ...e.target.files });

    //this.refs.fileInput.value = null;
  }
  handleSubmit(e) {
    e.preventDefault();
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  render() {
    var {
      buttonProps,
      containerProps,
      uploadProps
    } = this.props;
    return (
      <div className="fileinput text-center" {...containerProps}>
        <input {...uploadProps} type="file" onChange={this.handleChange} ref="fileInput" />
        <div>
            <Button {...buttonProps} onClick={() => this.handleClick()}>
              {this.props.children}
            </Button>
        </div>
      </div>
    );
  }
}

FileUploadButton.propTypes = {
  onFileReceived: PropTypes.func,
  buttonProps: PropTypes.any,
  uploadProps: PropTypes.any,
  containerProps: PropTypes.any
};

export default FileUploadButton;
